import React from "react";
// Go up 3 levels: tabs -> WeatherOverlay -> Map -> components
import DangerInfo from "../../../DangerInfo"; 

export default function DangerTab({ data, onClose }) {
  return (
    <div className="tab-content">
      <DangerInfo
        lat={data.lat}
        lon={data.lng}
        onClose={onClose}
        showEmptyState
      />
    </div>
  );
}
